// DEPRECATED use packages/client/ui/Button/Button.tsx with variant='flat'
import styled from '@emotion/styled'


import {PALETTE} from '../styles/paletteV3'
import {Radius} from '../types/constEnums'
import BaseButton, {} from './BaseButton'

const paletteColors = {
  warm: PALETTE.GOLD_500,
  mid: PALETTE.GRAPE_700,
  dark: PALETTE.SLATE_700,
  blue: PALETTE.SKY_500
}












const FlatButton = styled(BaseButton)((props) => {
  const {palette = 'dark', disabled, waiting} = props
  const visuallyDisabled = disabled || waiting
  return {
    backgroundColor: 'transparent',
    borderRadius: Radius.BUTTON_PILL,
    color: paletteColors[palette],
    outline: 0,
    ':hover,:focus,:active': {
      backgroundColor: !visuallyDisabled ? PALETTE.SLATE_200 : undefined,
      boxShadow: 'none'
    }
  }
})

export default FlatButton
